export type SvgProps = React.SVGProps<SVGSVGElement>;

export const Form = (props: SvgProps) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66683 10H13.3335V11.3333H6.66683V10ZM6.66683 14H11.3335V12.6667H6.66683V14ZM16.6668 7.05733V18H3.3335V4C3.3335 3.46957 3.54421 2.96086 3.91928 2.58579C4.29436 2.21071 4.80306 2 5.3335 2H11.6095L16.6668 7.05733ZM12.0002 6.66667H14.3908L12.0002 4.276V6.66667ZM15.3335 16.6667V8H10.6668V3.33333H5.3335C5.15668 3.33333 4.98712 3.40357 4.86209 3.5286C4.73707 3.65362 4.66683 3.82319 4.66683 4V16.6667H15.3335Z"
      fill="currentColor"
    />
  </svg>
);
